import React from "react";
import ApplyFrame from "./ApplyFrame";
import { StyledJumbotron } from "./JumbotronD2C.styles";

const onFinishEvent = () => {
  let baseUrl = "";

  if (GLOBAL_CONFIG.baseUrl !== "") {
    baseUrl = GLOBAL_CONFIG.baseUrl.charAt(0) !== "/" ? `/${GLOBAL_CONFIG.baseUrl}` : GLOBAL_CONFIG.baseUrl;
  }

  window.location.assign(baseUrl);
};

export const JumbotronD2C: React.VFC = () => (
  <StyledJumbotron>
    <div className="wrapper">
      <div className="iframeHeader">
        <span>Quick application to protect your loved ones.</span>
      </div>
      <div className="container">
        <ApplyFrame
          applyUri={GLOBAL_CONFIG.applyApiUrl}
          redirectUri={GLOBAL_CONFIG.createD2CApiUrl}
          formId=""
          questionPage=""
          onFinishEvent={onFinishEvent}
        />
      </div>
    </div>
  </StyledJumbotron>
);
